import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Pro Upgrade Overlay Component
 * Reusable component for showing pro upgrade messages
 */
const ProUpgradeOverlay = ({
  title,
  description,
  blurredContent,
  className = "",
  showButton = true,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className={`text-white p-6 bg-secondary/80 backdrop-blur-sm rounded-xl shadow-lg w-full max-w-4xl mx-auto border border-primary/20 ${className}`}
    >
      <div className="relative">
        <div className="blur-sm pointer-events-none">{blurredContent}</div>
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/50 rounded-xl">
          <p className="text-white text-xl font-bold mb-2">
            {title || t("history.proFeature")}
          </p>
          <p className="text-white text-center mb-4">
            {description || t("history.upgradeToPro")}
          </p>
          {showButton && (
            <button
              onClick={() => navigate("/settings")}
              className="bg-test hover:bg-secondary text-primary px-6 py-2 rounded-full shadow-sm transition duration-200"
            >
              {t("history.upgrade")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProUpgradeOverlay;
